"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Typing Component helps to ensure typing is always happening under a DOM container
 */
var TypeInContainerPlugin = /** @class */ (function () {
    function TypeInContainerPlugin() {
    }
    TypeInContainerPlugin.prototype.getName = function () {
        return 'TypeInContainer';
    };
    TypeInContainerPlugin.prototype.initialize = function (editor) {
        this.editor = editor;
    };
    TypeInContainerPlugin.prototype.dispose = function () {
        this.editor = null;
    };
    /**
     * Handle events triggered from editor
     * @param event PluginEvent object
     */
    TypeInContainerPlugin.prototype.onPluginEvent = function (event) {
        if (event.eventType == 1 /* KeyPress */) {
            this.onKeyPress(event);
        }
    };
    /**
     * Ensure we are typing in an HTML Element inside editor, and apply default format if current block is empty
     * @param node Current node
     * @param event (optional) The keyboard event that we are ensuring is typing in an element.
     * @returns A new position to select
     */
    TypeInContainerPlugin.prototype.ensureTypeInElement = function (position, event) {
        var result = position.normalize();
        var block = this.editor.getBlockElementAtNode(result.node);
        var formatNode;
        if (block) {
            formatNode = block.collapseToSingleElement();
            // if the block is empty, apply default format
            // Otherwise, leave it as it is as we don't want to change the style for existing data
            // unless the block was just created by the keyboard event (e.g. ctrl+a & start typing)
            var shouldSetNodeStyles = roosterjs_editor_dom_1.isNodeEmpty(formatNode) ||
                (event && this.wasNodeJustCreatedByKeyboardEvent(event, formatNode));
            formatNode = formatNode && shouldSetNodeStyles ? formatNode : null;
        }
        else {
            // Only reason we don't get the selection block is that we have an empty content div
            // which can happen when users removes everything (i.e. select all and DEL, or backspace from very end to begin)
            // The fix is to add a DIV wrapping, apply default format and move cursor over
            formatNode = roosterjs_editor_dom_1.fromHtml(roosterjs_editor_dom_1.Browser.isEdge ? '<div><span><br></span></div>' : '<div><br></div>', this.editor.getDocument())[0];
            this.editor.insertNode(formatNode, {
                position: 1 /* End */,
                updateCursor: false,
                replaceSelection: false,
                insertOnNewLine: false,
            });
            // element points to a wrapping node we added "<div><br></div>". We should move the selection left to <br>
            result = new roosterjs_editor_dom_1.Position(formatNode.firstChild, 0 /* Begin */);
        }
        if (formatNode) {
            roosterjs_editor_dom_1.applyFormat(formatNode, this.editor.getDefaultFormat(), this.editor.isDarkMode());
        }
        return result;
    };
    TypeInContainerPlugin.prototype.onKeyPress = function (event) {
        var _this = this;
        // If normalization was not possible before the keypress,
        // check again after the keyboard event has been processed by browser native behaviour.
        //
        // This handles the case where the keyboard event that first inserts content happens when
        // there is already content under the selection (e.g. Ctrl+a -> type new content).
        //
        // Only scheudle when the range is not collapsed to catch this edge case.
        var range = this.editor.getSelectionRange();
        if (!range || this.editor.contains(roosterjs_editor_dom_1.findClosestElementAncestor(range.startContainer))) {
            return;
        }
        if (range.collapsed) {
            this.tryNormalizeTyping(event, range);
        }
        else if (!range.collapsed) {
            this.editor.runAsync(function () {
                _this.tryNormalizeTyping(event);
            });
        }
    };
    /**
     * When typing goes directly under content div, many things can go wrong
     * We fix it by wrapping it with a div and reposition cursor within the div
     */
    TypeInContainerPlugin.prototype.tryNormalizeTyping = function (event, range) {
        var position = this.ensureTypeInElement(roosterjs_editor_dom_1.Position.getStart(range || this.editor.getSelectionRange()), event);
        this.editor.select(position);
    };
    TypeInContainerPlugin.prototype.wasNodeJustCreatedByKeyboardEvent = function (event, formatNode) {
        return (roosterjs_editor_dom_1.isNode(event.rawEvent.target) &&
            event.rawEvent.target.contains(formatNode) &&
            event.rawEvent.key === formatNode.innerText);
    };
    return TypeInContainerPlugin;
}());
exports.default = TypeInContainerPlugin;
//# sourceMappingURL=TypeInContainerPlugin.js.map